import { ISaveService } from "../../../../abstractions/services/actions/ISaveService";
import { AplicacionRequest } from "../../../../modulos/aplicaciones/request/AplicacionRequest";
import { AplicacionResponse } from "../../../../modulos/aplicaciones/response/AplicacionResponse";
import { AplicacionSaveGrpcService } from "../../../../modulos/aplicaciones/services/AplicacionSaveGrpcService";
import { serviceProvider } from "../../../../comun/provider/ServiceProvider";
import { BaseFullScreenFormModalRender } from "../../../base/modal/BaseFullScreenFormModalRender";
import { IFormBodyRender } from "../../../definitions/form/IFormBodyRender";
import { AplicacionFormRender } from "../form/AplicacionFormRender";

/** Modal a pantalla completa de creación/edición de una aplicación (vuelo).
 *  Hospeda el `AplicacionFormRender` y guarda con `AplicacionSaveGrpcService`. */
export class AplicacionFormModalRender extends BaseFullScreenFormModalRender<
  AplicacionRequest,
  AplicacionResponse
> {
  protected readonly elementId = "aplicacionFormModal";

  protected get title(): string {
    return "Aplicación Finca";
  }

  protected get subtitle(): string | undefined {
    return serviceProvider.getFincaSelectedService().get()?.nombreFinca;
  }

  protected get saveLabel(): string {
    return "Registrar Aplicación";
  }

  protected getFormBody(): IFormBodyRender {
    return new AplicacionFormRender(this._request);
  }

  protected get saveService(): ISaveService<
    AplicacionRequest,
    AplicacionResponse
  > {
    return new AplicacionSaveGrpcService();
  }
}
